import React, { Component } from "react";

const mono = "'JetBrains Mono', 'Fira Code', monospace";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: "100vh",
          background: "var(--bg-root)",
          color: "var(--text-main)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: mono,
          padding: "20px",
          textAlign: "center"
        }}>
          <div style={{
            background: "var(--bg-card)",
            border: "1px solid #ff525250",
            borderRadius: "12px",
            padding: "30px",
            maxWidth: "500px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.5)"
          }}>
            <h2 style={{ color: "#ff5252", fontSize: "18px", fontWeight: 700, margin: "0 0 12px" }}>
              Something went wrong
            </h2>
            <p style={{ color: "var(--text-muted)", fontSize: "12px", lineHeight: 1.6, margin: "0 0 20px" }}>
              An unexpected error occurred in this view. Please try reloading the page or contact support if the issue persists.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: "#1f6feb",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                padding: "8px 18px",
                fontSize: "12px",
                fontWeight: 700,
                fontFamily: mono,
                cursor: "pointer"
              }}
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
